import { useNavigate } from "react-router-dom";
import { menus } from "./data/data";

export default function Sidebar({ onClosed }) {
  const navigate = useNavigate();
  const handleLink = (item) => {
    onClosed && onClosed();
    if (item.link) {
      navigate(item.link);
    }
  };
  return (
    <div className="sidebar">
      <div
        className="profile cursor-pointer"
        onClick={() => handleLink({ link: "/" })}
      >
        <li className="centerXY flex-col">
          <h1 className="text-secondary-300 ">S</h1>
          <h3 className="text-primary-100">Sayeem</h3>
          <h5 className="text-primary-400">Web Developer</h5>
        </li>
      </div>
      <div className="menuContainer py-12 ">
        {menus?.map((item) => (
          <li
            key={item.id}
            onClick={() => handleLink(item)}
            className="h-12 centerXY border-t border-t-primary-800 cursor-pointer text-primary-400 hover:text-secondary-300"
          >
            <h4>{item.title}</h4>
          </li>
        ))}
      </div>
    </div>
  );
}
